//////画像切り替え
$(function () {
  var width = $(window).width();
  if( width < 900 ){
    $("img").each(function(){
      $(this).attr("src", $(this).attr("src").replace("_pc","_sp"));
    })
  }
});

//////ナビゲーション
$(function(){
  $('.menu_trigger').on('click', function () {
    $(this).toggleClass('active');
    $('.header_nav_contents').slideToggle();
    $('.header_contents').toggleClass('nav_active');
  });
});
$('.header_nav_contents a').on('click', function(){
  if (window.innerWidth <= 900) {
    $('.menu_trigger').click();
  }
});	
$(window).on('resize', function() {
	if( 'none' == $('.header_nav_contents').css('display') ){
		$('.header_nav_contents').attr('style','');
	}
});

/////header
$(window).scroll(function(){
  if ($(window).scrollTop() > 80) {
    $('header').addClass('header_active');
  } else {
    $('header').removeClass('header_active');
  }
});
//////スムーススクロール
var headerHeight = $('header').outerHeight();     //fixedのヘッダーの高さを取得
var urlHash = location.hash;    //URLハッシュを取得
var animeSpeed = 700;   //スクロールのアニメーションスピード
if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
        var target = $(urlHash);
        var position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, animeSpeed);
    }, 100);
}
$('a[href^="#"]').on({
    'click': function(){
        var href= $(this).attr("href");
        var target = $(href);
        var position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, animeSpeed);   
    }
});


//////ページトップ
$(function(){
    $("#page-top").hide();
    $(window).on("scroll", function() {
        if ($(this).scrollTop() > 650) {
            $("#page-top").fadeIn("fast");
        } else {
            $("#page-top").fadeOut("fast");
        }
        scrollHeight = $(document).height();
        scrollPosition = $(window).height() + $(window).scrollTop();
        footHeight = $("footer").innerHeight();
        if ( scrollHeight - scrollPosition  <= footHeight ) {
            $("#page-top").css({
                "position":"absolute",
                "bottom": footHeight + 10
            });
        } else {
            $("#page-top").css({
                "position":"fixed",
                "bottom": "1em"
            });
        }
    });
    $('#page-top').click(function () {
        $('body,html').animate({
        scrollTop: 0
        }, 1000);
        return false;
    });
});
//////kv
$(function() {
	$('.kv_item').on('init', function(event, slick){
		console.log('.kv_item init');
    AOS.init({duration: 1100,});
	});
	$('.kv_item').slick({ 
    speed: 1500,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true,
    dotsClass: "slide_dots",
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true
	});
});
$(window).on('load',function()
{setTimeout(function(){
$('.kv_item').slick();
},30);
});

//contact(WP)
$(function(){
  if ( $('.error')[0] ) {
    $('.mw_wp_form').addClass('mw_wp_form_error');
  }
});
jQuery(function($){
  const Target = $('.is-empty');
  $(Target).on('change', function(){
    if ($(Target).val() !== ""){
      $(this).removeClass('is-empty');
    } else {
      $(this).addClass('is-empty');
    }
  });
});
